import { ICountry, IUser, IUserAccount } from '@boma/client-shared';
import { IGeography, IProfileEntityDetail } from '../..';
import { IEntityOrderLocationDetails } from './i-location';
import { IProduct } from './i-product';
import { IJournalStatus } from './i-journal-status';

export interface Item {
  id: string;
  price: number;
  taxRate: number;
  quantity: number;
  product: IProduct;
}

export interface IOrderChargeEvent {
  type: string;
  createdAt: Date;
}

export interface IOrderCharge {
  id: string;
  type: string;
  status: string;
  total: number;
  totalVat: number;
  totalWithoutVat: number;
  items: Item[];
  events: IOrderChargeEvent[];
}

export interface IOrderEvent {
  status?: any;
  point?: IGeography;
  id: string;
  stockEventId: string;
  type: string;
  comment: string;
  createdAt: Date;
}

export interface Entity {
  id: string;
  name: string;
  tradingName: string;
  type: string;
}

export class IOrder {
  batchId?: string;
  id: string;
  reference: string;
  orderDate: Date;
  status: string;
  charges: IOrderCharge[];
  events: IOrderEvent[];
  entity: IProfileEntityDetail;
  receivingEntity: IProfileEntityDetail;
  originIsSupplier: boolean;
  originLocationName: string;
  supplyingLocationName: string;
  receivingLocationName: string;
  createdBy: IUserAccount;
  locationDetails: {
    supplyingLocationDetails: IEntityOrderLocationDetails;
    receivingLocationDetails: IEntityOrderLocationDetails;
  };
  currencySymbol: string;
  createdAt: string;
  selected?: boolean;

  constructor(init?: Partial<IOrder>) {
    if (init) {
      Object.assign(this, init);
    }
  }
}

export class IOrderDetail extends IOrder {
  batchId: string;
  countryName: string;
  deliveryHandshake: IOrderDeliveryHandshake;
  country: ICountry;
  hasDeliveryVehicle: boolean;
  originLocation: IOrderLocation;
  receivingLocation: IOrderLocation;
  supplyingLocation: IOrderLocation;
  modifiedJournalNewStatus: IJournalStatus;
  isDebitNote?: boolean; // Flag to indicate if this order is a debit note

  constructor(init?: Partial<IOrderDetail>) {
    if (init) {
      super(init);
      Object.assign(this, init);
    }
  }
}

export interface IOrderItem {
  productId: string;
  units: number;
  price: number;
}

export interface IOrderCreate {
  receivingLocationId: string;
  supplyingLocationId: string;
  items: IOrderItem[];
  isPosSale: boolean;
  comment: string;
}

export interface IOrderBatchResponse {
  id: string;
  orders: IOrder[];
}

export interface IOrderLocation {
  point?: IGeography;
  id: string;
  name: string;
  openingTime: string;
  closingTime: string;
  contactPersonName: string;
  contactPersonNumber: string;
}

export interface IOrderDeliveryHandshake {
  acceptedBy?: IUser;
  deliveredBy?: IUser;
}
